import { render, staticRenderFns } from "./CommunityShare.vue?vue&type=template&id=5d7abf50&scoped=true&"
import script from "./CommunityShare.vue?vue&type=script&lang=js&"
export * from "./CommunityShare.vue?vue&type=script&lang=js&"
import style0 from "./CommunityShare.vue?vue&type=style&index=0&id=5d7abf50&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7abf50",
  null
  
)

export default component.exports